import { render, staticRenderFns } from "./openAccountAndUser.vue?vue&type=template&id=35e46df2&scoped=true"
import script from "./openAccountAndUser.vue?vue&type=script&lang=js"
export * from "./openAccountAndUser.vue?vue&type=script&lang=js"
import style0 from "./openAccountAndUser.vue?vue&type=style&index=0&id=35e46df2&prod&lang=scss&scoped=true"
import style1 from "./openAccountAndUser.vue?vue&type=style&index=1&id=35e46df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e46df2",
  null
  
)

export default component.exports